// @ts-nocheck
import { replaceAllNotDigitsTextCursor } from '../replaceWithCursorPosition';

export class MaskPhoneBr {
  public maxLength = 11;

  constructor(_view: any, public assets: any) {}

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const { newValue, newCursorPosition } = replaceAllNotDigitsTextCursor(value, cursorPosition);

    if (newValue.length > this.maxLength) {
      return {
        newValue: newValue.substr(0, this.maxLength),
        newCursorPosition: newCursorPosition >= this.maxLength ? this.maxLength : newCursorPosition,
      };
    }

    return { newValue, newCursorPosition };
  }

  public setMask(value: string, cursorPosition): { formatedValue; formatedCursorPosition } {
    try {
      if (value.length <= 2) {
        return { formatedValue: value, formatedCursorPosition: cursorPosition };
      } else if (value.length <= 6) {
        const formatedValue = value.replace(/^(\d{2})(\d{1,4})$/, '($1) $2');
        const formatedCursorPosition = cursorPosition < 3 ? cursorPosition + 1 : cursorPosition + 3;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (value.length <= 10) {
        const formatedValue = value.replace(/^(\d{2})(\d{4})(\d{1,4})/, '($1) $2 - $3');

        let formatedCursorPosition = cursorPosition + 1;
        if (cursorPosition >= 3) formatedCursorPosition = formatedCursorPosition + 2;
        if (cursorPosition >= 7) formatedCursorPosition = formatedCursorPosition + 3;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else {
        const formatedValue = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2 - $3');

        let formatedCursorPosition = cursorPosition + 1;
        if (cursorPosition >= 3) formatedCursorPosition = formatedCursorPosition + 2;
        if (cursorPosition >= 7) formatedCursorPosition = formatedCursorPosition + 3;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      }
    } catch (err) {
      console.error('Error: ', err);
      return { formatedValue: value, formatedCursorPosition: cursorPosition };
    }
  }

  public validate(value) {
    const regexTest = new RegExp(/^\([1-9][0-9]\) (?:[2-8]|9[1-9])[0-9]{3} - [0-9]{4}$/);
    return value.length >= 16 ? regexTest.test(value) : true;
  }

  public getMaskErrors() {
    return [this.assets.labels.feedbacks.masks['PHONE_BR']];
  }
}
